import { useState, useEffect } from 'react';
import Navbar from './Navbar'
import Footer from './Footer'

function Aboutme() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
    <main className='px-8 md:px-20 lg:px-40'>
    
    <Navbar />

    <section id='home' className='text-center mt-40 flex flex-col justify-center'>
        <h1 className='text-3xl md:text-5xl font-medium text-teal-500'>Bingjian Huang</h1>
        <h3 className='text-xl mt-10 md:text-2xl'>Researcher, HCI, XR, Haptics, Electronics</h3>
    </section>

    <section id='content' className='min-h-screen mt-10 max-w-screen-md mx-auto text-justify' >
        <p className='text-lg mt-10'>
            Currently I'm a sixth-year Ph.D. candidate from the dynamic graphics project (DGP) Lab at the University of Toronto, supervised by <a href="https://www.dgp.toronto.edu/~dwigdor/" className='text-blue-500'>Prof. Daniel Wigdor</a>.
        </p>
        <p className='text-lg mt-3'>
            My research aims to use human-centered research methods to solve haptics problems, from understanding human tactile perception to building innovate tactile toolkits and enabling applications in extended reality, accessibility, and human-robot interaction. My research is published in top venues such as Transactions on Haptics, CHI, and RA-L. 
        </p>
        <p className='text-lg mt-3'>
            Before that, I conducted research at <a href="http://pi.cs.tsinghua.edu.cn/" className='text-blue-500'>the Key Laboratary of Pervasive Computing</a> at Tsinghua University (April, 2018 to November, 2019).
            My advisors are <a href="http://pi.cs.tsinghua.edu.cn/lab/people/shiyc/" className='text-blue-500'>Prof. Yuanchun Shi</a> and <a href="http://pi.cs.tsinghua.edu.cn/lab/people/ChunYu/" className='text-blue-500'>Prof. Chun Yu</a>.
            I participated in two research projects related to Telepresence and Holoportation in Virtual Reality(VR) and dual-handed Gesture Design on smartwatch. Paper was published on IMWUT 2019.
        </p>
        <p className='text-lg mt-3'>
            In Summer 2019, I worked as a summer intern in <a href="http://www.intecolab.com/" className='text-blue-500'>Inteco Lab</a> (Advisor: <a href="http://mwnewman.people.si.umich.edu/" className='text-blue-500'>Prof. Mark W. Newman</a>) at School of Information, University of Michigan, Ann Arbor.
            I collaborated with PhD student Xinghui Yan on a research project about low-burden in-situ self-reporting tools. Paper was published on IMWUT 2020 and MobileHCI 2021.
        </p>
        <p className='text-lg mt-3'>
            If you are interested in knowing more about me, please refer to my <a href="/cv">CV</a> and <a href="/portfolio">Portfolio</a>.
        </p>
    </section>

    <Footer />

    </main>
  );
}

export default Aboutme;
